import Moment from 'moment';
import { IServiceIntervalRequest, IServiceArriveTimeRequest } from './service';

export const enum CalendarType {
    Classic = 1,
    Timetable = 2
}

export interface IInterval {
    Start: string,
    End: string,
    Reserved?: boolean,
}

export interface IDateInterval {
    Date: string;
    Intervals: IInterval[];
}

export interface IDateIntervalByCalendar {
    Intervals: IDateInterval[],
    CalendarId: number,
    DayStart: string,
    DayEnd: string
}

export interface ICalendarBase {
    Id: number;
    Name: string;
    Type: CalendarType;
}

export const enum TimeTableViewType {
    AgendaDay,
    BasicDay,
    AgendaWeek,
    BasicWeek,
    Month
}

export const enum ClassicViewType {
    DateAndTime,
    Calendar
}

export interface ICalendar extends ICalendarBase {
    WeeksForward: number;
    ConcurrentNum: number;
    DayStart: string;
    DayEnd: string;
    MinTimeModify: number;
    MinTimeReserve: number;
    Readonly: boolean;
    ShortDescription: string | null;
    Description: string | null;
    PictureLink: string | null;
    GoogleCalendarName?: string;
    WeekendDisabled: boolean;
    UserViewSlotMinutes: number;
    ClassicCustomerViewType: ClassicViewType;
    DefaultCustomerView: TimeTableViewType;
    IsTimeSelectDropDown: boolean;
    HideSeatCount: boolean;
    PhoneNumber?: string;
}

export interface ICalendarIntervals {
    Intervals: IDateInterval[];
    MinTimeReserve: number
}

export interface ICalendarIntervalRequest extends IServiceIntervalRequest {
    calendarId: number;
}
export interface ICalendarAllIntervalRequest {
    calendarIds: string[];
    startDate: string;
    endDate: string;
    personCount?: number;
}

export interface ICalendarArriveTimeRequest extends IServiceArriveTimeRequest {
    calendarId: number;
}

export const randomCalendarItem: ICalendar = {
    Id: 0,
    Name: 'Mindegy',
    WeeksForward: 0,
    ConcurrentNum: 0,
    Readonly: false,
    Type: 0,
    DayStart: '08:00',
    DayEnd: '20:00',
    Description: '',
    ShortDescription: '',
    MinTimeModify: 0,
    MinTimeReserve: 0,
    PictureLink: '',
    WeekendDisabled: false,
    UserViewSlotMinutes: 60,
    ClassicCustomerViewType: ClassicViewType.DateAndTime,
    DefaultCustomerView: TimeTableViewType.Month,
    IsTimeSelectDropDown: false,
    HideSeatCount: false
};

export const isRandomCalendar = (calendarId: number): boolean => {
    return calendarId === 0;
}

export const isAppointmentCalendar = (calendar?: ICalendar): boolean => {
    if (!calendar) {
        return false;
    }
    return calendar.ClassicCustomerViewType === ClassicViewType.Calendar;
}

export const getCalendarMaxDate = (weeksForward: number): string => {
    return Moment().add(weeksForward, 'weeks').endOf('week').toISOString()
}